<template>
    <div>
        <FormPage :id="userId" :initialData="userData" :formFields="formFields" />
    </div>
</template>

<script>
import FormPage from './FormPage.vue';

export default {
    components: {
        FormPage,
    },
    data() {
        return {
            userId: 123,
            userData: {
                name: 'John Doe',
                age: 30,
                gender: 'male',
                isCool: 'B',
                isLonely: false,
                isLonely2: true
            },
            formFields: {
                name: {
                    label: 'Name',
                    type: 'text',
                    placeholder: 'Enter your name',
                    component: 'input',
                },
                age: {
                    label: 'Age',
                    type: 'number',
                    placeholder: 'Enter your age',
                    component: 'input',
                },
                textBlock: {
                    label: 'Description',
                    component: 'textarea',
                    placeholder: 'Enter a description',
                },
                isCool: {
                    label: 'Is Cool',
                    component: 'radio-group',
                    options: [
                        { value: 'A', label: 'Un peu' },
                        { value: 'B', label: 'Beaucoup' },
                        { value: 'C', label: 'Trop' },
                    ]
                },
                isLonely: {
                    label: 'Is Lonely',
                    component: 'checkbox-group',
                    options: [
                        { value: 'True', label: 'Oui' }
                    ]
                },
                isLonely2: {
                    component: 'checkbox-group',
                    options: [
                        { value: 'True', label: 'Oui' }
                    ]
                }
            },
        };
    },
};
</script>